import { useEffect } from 'react';
import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import TermikoSection from './components/TermikoSection';
import SocialProofSection from './components/SocialProofSection';
import B2cSection from './components/B2cSection';
import FormSection from './components/FormSection';
import FooterSection from './components/FooterSection';
import MobileBottomBar from './components/MobileBottomBar';
import SeoHead from './components/SeoHead';
import { trackEvent } from '../../utils/analytics';

export default function HomePage() {
  useEffect(() => {
    trackEvent('page_view', 'Home page', 'page');
  }, []);

  return (
    <div className="min-h-screen pb-[72px] md:pb-0">
      <SeoHead />
      <NavBar />
      <main aria-label="Punto Cassonetti – Cassonetti PVC e Controtelai Termici Made in Italy">
        <HeroSection />
        <ProductsSection />
        <TermikoSection />
        <SocialProofSection />
        <B2cSection />
        <FormSection />
      </main>
      <FooterSection />

      {/* WhatsApp float — desktop only */}
      <a
        href="https://wa.me/393939932439?text=Ciao%2C%20sono%20interessato%20a%20un%20preventivo%20per%20cassonetti%20o%20controtelai."
        target="_blank"
        rel="noopener noreferrer nofollow"
        onClick={() => trackEvent('whatsapp_click', 'WhatsApp flottante', 'float_button')}
        className="hidden md:flex fixed bottom-6 right-6 z-50 w-14 h-14 items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Contattaci su WhatsApp per preventivo cassonetti PVC"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>

      {/* Mobile bottom nav */}
      <MobileBottomBar />
    </div>
  );
}
